import { useState } from 'react';
import { Box, Button, ButtonGroup } from '@mui/material';

interface ButtonProps {
  choices?: (string | null)[] | null;
  actionType?: string | null;
  actionValue?: (string | null)[] | null;
}

export const FinishButton: React.FC<ButtonProps> = ({ choices = [], actionType, actionValue = [] }) => {
  const [disabled, setDisabled] = useState(false);

  const buttonPush = () => {
    setDisabled(true);
    const url = actionValue && actionValue[0];
    if (actionType === 'uri' && url) {
      window.location.href = url;
    }
  };

  if (!choices || !choices[0]) return null;

  return (
    <Box className="flex justify-center">
      <Button
        className={`w-6/12 h-auto my-2 mx-auto py-2 ${
          disabled ? 'bg-zinc-300 text-zinc-700' : 'bg-primary text-white'
        } text-sm font-semibold`}
        onClick={buttonPush}
        disabled={disabled}
      >
        {choices[0]}
      </Button>
    </Box>
  );
};

export const ChoiceButtons: React.FC<ButtonProps> = ({ choices = [], actionType, actionValue = [] }) => {
  const [disabledNumber, setDisabledNumber] = useState<number | null>(null);

  const buttonPush = (index: number) => {
    setDisabledNumber(index);
    const url = actionValue && actionValue[index];
    if (actionType === 'uri' && url) {
      window.location.href = url;
    }
  };

  if (!choices || choices.length === 0) return null;

  return (
    <Box className="flex justify-center">
      <ButtonGroup orientation="vertical" className="w-6/12" aria-label="Choice button group">
        {choices.map(
          (choice, index) =>
            choice ? (
              <Button
                key={index}
                className={`w-full h-auto mx-auto py-2 border-solid border-1 border-primary ${
                  disabledNumber === index ? 'bg-zinc-300 text-zinc-700' : 'bg-white text-primary'
                } text-base font-semibold`}
                onClick={() => buttonPush(index)}
                disabled={disabledNumber === index}
              >
                {choice}
              </Button>
            ) : null // null の要素があればレンダリングしない
        )}
      </ButtonGroup>
    </Box>
  );
};
